import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW9200Model } from '../kymw9200.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * eBase仕様書No存在チェックするサービス
 * @export GetCatalogInfoListService
 * @class GetCatalogInfoListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCatalogInfoListService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW9200Model;
  vo = {
    orderCodeFrom : '',
    orderCodeTo : ''
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCatalogInfoListService
   */
  private getBody(): PlessRequest {
      return new PlessRequest({
        parameter: {
          OrderCodeFrom: this.vo.orderCodeFrom,
          OrderCodeTo: this.vo.orderCodeTo
        }
      });
    }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCatalogInfoListService
   */
  execute(model: KYMW9200Model, vo: any): void {
    this.model = model;
    this.vo = vo;
    this.send('getCatalogInfoList', this.getBody());
}

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCatalogInfoListService
   */
  success(data: any) {
    if (data !== null) {
      // サイクル企画確定日をタイムスタンプ型から日付に変換
      data.Catalog.List.forEach(item => {
        if (item.CycleConfirmedDate !== '') {
          item.CycleConfirmedDate = Intl.DateTimeFormat('ja-JP', {
            timeZone: 'JST', year: 'numeric', month: '2-digit', day: '2-digit'
          }).format(new Date(item.CycleConfirmedDate));
        }
      });

      // 企画回一覧情報
      this.model.getCatalog(data);
    }
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    this.model.clean();
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    this.model.clean();
    super.exceptionError(status, result);
  }
}
